import type { NavSection } from "@/lib/constants";
import { isFeatureEnabled } from "@/lib/feature-flags";

/**
 * Filters `NavItem.flag`-gated items out of a nav-section constant unless
 * their flag is enabled, and drops any section left with no items. Shared
 * by AppLayout and DeveloperLayout so a flagged nav entry (ALL-5039, HW-L9a)
 * never appears in the sidebar while its flag is off, without forking the
 * exported NAV_SECTIONS constants per layout.
 */
export function visibleNavSections(sections: NavSection[]): NavSection[] {
  return sections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => !item.flag || isFeatureEnabled(item.flag)),
    }))
    .filter((section) => section.items.length > 0);
}
